import axios from "axios";

export const fetchUpdateTaskTemplate = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

  return await axios.put(`${baseTaskUrl}/TaskTemplate/${data.id}`, data);
};
